"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseRelatedArticlesList = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BaseRelatedArticlesList = _styledComponents.default.ul.withConfig({
  displayName: "styles__BaseRelatedArticlesList",
  componentId: "sc-81ychv-0"
})(["list-style:none;padding:0px;display:flex;flex-wrap:wrap;"]);
exports.BaseRelatedArticlesList = BaseRelatedArticlesList;